import { __extends } from "tslib";
/**
 * Created by Kamil.Adamuszek on 2016-03-22.
 * Updated by Maks.Pryliński on 2020-02-05 - Toyota Redesign - Unification Article and Section component into Template
 */
import BSSAbstractComponent from '../../bss-abstract-component/js/bss-abstract-component.js';
import template from '../template/template.hbs';
import gridTemplate from '../template/grid.hbs';
import gridTwoColumns from '../template/grid-two-columns.hbs';
import gridRowsTemplate from '../template/grid-rows.hbs';
import co2Template from '../template/co2.hbs';
import contactTemplate from '../template/contact.hbs';
import newTemplate from '../template/newTemplate.hbs';
import carItemTemplate from '../template/car-item.hbs';
import carItemListTemplate from '../template/car-item-list.hbs';
import componentContainer from '../template/componentContainer.hbs';
import lexusSummary from '../template/lexusSummary.hbs';
import dateTemplate from '../template/date.hbs';
import carDetailsTemplate from '../template/car-details.hbs';
import fixedContainerTemplate from '../template/fixedContainer.hbs';
import rightBoxTemplate from '../template/right-box.hbs';
import rightBoxFinalStepTemplate from '../template/right-box-finalStep.hbs';
import rightBoxGBTemplate from '../template/rightBoxGB.hbs';
import itemTitleTextIconTemplate from '../template/itemTitleTextIcon.hbs';
import articleTemplate from '../template/article.hbs';
import sectionTemplate from '../template/section.hbs';
import imageTemplate from '../template/image.hbs';
import logger from '@main/externals/bss-package-logger/js/logger';
import fixedContainerGridTemplate from '../template/fixedContainerGrid.hbs';
/**
 * BSSComponentSkeleton class
 */
var templateObject = {
    defaultTemplate: template,
    grid: gridTemplate,
    gridTwoColumns: gridTwoColumns,
    gridRows: gridRowsTemplate,
    co2Template: co2Template,
    contactTemplate: contactTemplate,
    newTemplate: newTemplate,
    carItemTemplate: carItemTemplate,
    componentContainer: componentContainer,
    carItemListTemplate: carItemListTemplate,
    lexusSummary: lexusSummary,
    dateTemplate: dateTemplate,
    carDetailsTemplate: carDetailsTemplate,
    rightBoxTemplate: rightBoxTemplate,
    rightBoxFinalStepTemplate: rightBoxFinalStepTemplate,
    rightBoxGBTemplate: rightBoxGBTemplate,
    fixedContainerTemplate: fixedContainerTemplate,
    fixedContainerGridTemplate: fixedContainerGridTemplate,
    itemTitleTextIconTemplate: itemTitleTextIconTemplate,
    articleTemplate: articleTemplate,
    sectionTemplate: sectionTemplate,
    imageTemplate: imageTemplate,
};
var BSSTemplateComponent = /** @class */ (function (_super) {
    __extends(BSSTemplateComponent, _super);
    /**
     *
     * @param {String} [_entityTemplate=null] _entityTemplate entity template
     * @param {String} [containerSelector=null] containerSelector component container selector
     * @param {Object} [config=null] config configuration of component
     * @param {EventManager} [eventManager=null] instance of _EventManager
     * @param {Formatter} [formatter=null] instance of Formatter
     * @param {Resolution} [resolution=null] Resolution class for width breakpoint handling
     * @param {Toolbox} [toolbox=null] instance of Toolbox object
     */
    function BSSTemplateComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        if (_entityTemplate === void 0) { _entityTemplate = null; }
        if (containerSelector === void 0) { containerSelector = null; }
        if (config === void 0) { config = null; }
        if (eventManager === void 0) { eventManager = null; }
        if (formatter === void 0) { formatter = null; }
        if (resolution === void 0) { resolution = null; }
        if (toolbox === void 0) { toolbox = null; }
        var _this = this;
        if (toolbox.$(config.outsideEntityContainer).length) {
            toolbox
                .$(config.outsideEntityContainer)
                .addClass(toolbox.$('#onlineApproval').attr('class'));
        }
        _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, templateObject, toolbox) || this;
        _this._componentVersion = '@@name ver. @@version';
        logger.info('TemplateComponent ' +
            config.componentType +
            ' => constructor : componentId: ' +
            config.componentId +
            ' | Params', config, eventManager, formatter, resolution, logger, toolbox);
        if (_this._config.componentTemplate === 'carItemListTemplate') {
            _this._createCarItemListComponent();
        }
        if (_this._config.fixedPosition) {
            _this._initializeFixedContainer();
        }
        else if (_this._config.inBody) {
            if (_this._config.dependsSelector) {
                /**
                 * @type {jQuery|HTMLElement}
                 * @desc active product container
                 * @private
                 */
                _this._activeProduct = _this._htmlBody.find(_this._config.dependsSelector);
            }
            else {
                _this._activeProduct = null;
            }
            if (_this._activeProduct && _this._activeProduct.length === 1) {
                _this._componentTemplate.addClass('is-active');
            }
        }
        return _this;
    }
    /**
     * @desc is use to prepare config data of the component, if necessary implement in the specific component
     * @override
     * @private
     */
    BSSTemplateComponent.prototype._prepareData = function () {
        logger.info('TemplateComponent: ' +
            this._config.componentId +
            ' => function : _prepareData');
        if (this._config.componentTemplate === 'carItemTemplate') {
            logger.info('TemplateComponent: ' +
                this._config.componentId +
                ' => function : _prepareData');
            var startObj = this._getValueObject(this._config.variable);
            this._config.componentData.price = this._formatter.getFormattedValue(this._config.componentData.price, startObj.formatter);
        }
        else if (this._config.componentTemplate === 'rightBoxGBTemplate') {
            for (var i = 0; i < this._config.simulator.length; i++) {
                if (this._config.simulator[i].originValue) {
                    this._config.simulator[i].originValue = this._getBoundedString(this._config.simulator[i].originValue);
                }
            }
            var self_1 = this;
            this._toolbox._.forEach(this._config.model, function (value, name) {
                var $tag = self_1._toolbox.$(value);
                var text = $tag.data().text ? $tag.data().text : null;
                var typeText = null;
                if (text) {
                    typeText = text.split('.')[0];
                }
                if (typeText === 'general') {
                    self_1._config.model[name] = self_1._getBoundedString(value, true);
                }
                else {
                    self_1._config.model[name] = self_1._getBoundedString(value);
                }
            });
        }
    };
    /**
     * @desc method changes component scope for some templates
     * @override
     * @private
     */
    BSSTemplateComponent.prototype._prepareComponentScope = function () {
        logger.info('TemplateComponent: ' +
            this._config.componentId +
            ' => function : _prepareComponentScope');
        //grid, componentContainer, fixedContainerTemplate, gridRows are components which provides empty containers where we put another components
        //we don't need double update
        if (this._config.componentTemplate === 'grid' ||
            this._config.componentTemplate === 'componentContainer' ||
            this._config.componentTemplate === 'fixedContainerTemplate' ||
            this._config.componentTemplate === 'fixedContainerGridTemplate' ||
            this._config.componentTemplate === 'gridRows') {
            //we set empty jQuery object
            this._componentScope = this._toolbox.$();
        }
    };
    /**
     * @desc create car-item list component based on config.
     * @private
     */
    BSSTemplateComponent.prototype._createCarItemListComponent = function () {
        logger.info('BSSTemplateComponent: ' +
            this._config.componentId +
            ' => function : _createCarListComponent');
        this._carComponents = [];
        var commonCarItemInfo = this._prepareCommonCarItemInfo();
        var modelsList = this._config.resultData.models;
        for (var index = 0; index < modelsList.length; index++) {
            var carModel = modelsList[index];
            var carItem = this._createCarItemComponentAndAttachToParent(carModel, commonCarItemInfo);
            this._carComponents.push(carItem);
        }
    };
    /**
     * @desc create commonCarItemInfo object which include common settings  for car item (for e.g: labels, type, class)
     * @return {object} commonCarItemInfo - created car item info instance includes common data for car item
     * @private
     */
    BSSTemplateComponent.prototype._prepareCommonCarItemInfo = function () {
        logger.info('BSSTemplateComponent: ' +
            this._config.componentId +
            ' => function : _prepareCommonCarItemInfo');
        var commonCarItemInfo = this._config.baseModelConfig;
        commonCarItemInfo.pricePrefix =
            this._config.layout.texts.general.car_configurator_starting_price;
        commonCarItemInfo.countPostfix =
            this._config.layout.texts.general.car_configurator_versions;
        return commonCarItemInfo;
    };
    /**
     * @desc create car-item component  based on config. Car-item will be attached to parent component
     * @param {object} carModel - car model data from json
     * @param {object} commonCarItemInfo -  car item info instance includes common data for car item
     * @return {object} carItemTemplate - created car item instance
     * @private
     */
    BSSTemplateComponent.prototype._createCarItemComponentAndAttachToParent = function (carModel, commonCarItemInfo) {
        logger.info('BSSTemplateComponent: ' +
            this._config.componentId +
            ' => function : _createCarItemComponentAndAttachToParent' +
            ' | Params: ', carModel, commonCarItemInfo);
        var carConfig = this._prepareConfigForCarModel(carModel, commonCarItemInfo);
        carConfig.testId = "".concat(this._config.testId, "_car-template");
        return new BSSTemplateComponent(this._entityTemplate, '#' + this._config.componentId, carConfig, this._eventManager, this._formatter, this._resolution, this._toolbox);
    };
    /**
     * @desc prepare car item configuration for car model
     * @param {object} carModel - car model data from json
     * @param {object} commonCarItemInfo -  car item info instance includes common data for car item
     * @return {object} carConfig - car item config prepared for input car model.
     * @private
     */
    BSSTemplateComponent.prototype._prepareConfigForCarModel = function (carModel, commonCarItemInfo) {
        logger.info('BSSTemplateComponent: ' +
            this._config.componentId +
            ' => function : _prepareConfigForCarModel' +
            ' | Params: ', carModel, commonCarItemInfo);
        var carConfig = {
            componentData: {
                pricePrefix: commonCarItemInfo.pricePrefix,
                price: carModel.price,
                modelId: carModel.modelId,
                modelName: carModel.modelName,
                count: carModel.count,
                countPostfix: commonCarItemInfo.countPostfix,
                imageUrl: carModel.imageUrl,
            },
            entityId: carModel.modelId,
            componentId: commonCarItemInfo.componentId + '-' + carModel.modelId,
            componentType: commonCarItemInfo.componentType,
            containerId: commonCarItemInfo.containerId,
            componentTemplate: commonCarItemInfo.componentTemplate,
            class: commonCarItemInfo.class,
            resultData: {},
            variable: commonCarItemInfo.variable,
            texts: this._config.texts,
            productId: this._config.productId,
        };
        for (var index = 0; index < carConfig.productId.length; index++) {
            var carConfigProduct = carConfig.productId[index];
            carConfig.resultData[carConfigProduct] =
                this._config.resultData[carConfigProduct];
        }
        return carConfig;
    };
    /**
     * @desc initialize fixed container method
     * @private
     */
    BSSTemplateComponent.prototype._initializeFixedContainer = function () {
        logger.info('BSSTemplateComponent ' +
            this._config.componentId +
            ' => function : _initializeFixedContainer');
        /**
         * @type {boolean}
         * @private
         * @desc describe that simulator is in popup, if this._entity Template has attribute: is-popup - set this value for this parameter
         */
        this._isInPopup = this._entityTemplate.attr('is-popup')
            ? JSON.parse(this._entityTemplate.attr('is-popup'))
            : typeof this._config.isInPopup === 'undefined'
                ? false
                : this._config.isInPopup;
        /**
         * @type {jQuery|HTMLElement}
         * @private
         * @desc global window element
         */
        this._globalWindow = null;
        /**
         * @type {jQuery|HTMLElement}
         * @private
         * @desc global html, body element
         */
        this._globalHtmlBody = null;
        /**
         * @type {boolean}
         * @private
         * @desc tor popup
         */
        this._torPopup = null;
        if (this._isInPopup) {
            if (this._config.modalContainer) {
                if (typeof this._config.modalContainer === 'object') {
                    this._globalWindow = this._componentScope.closest(this._toolbox.$(this._config.modalContainer[0])).length
                        ? this._toolbox.$(this._config.modalContainer[0])
                        : this._toolbox.$(this._config.modalContainer[1]);
                    this._globalHtmlBody = this._componentScope.closest(this._toolbox.$(this._config.modalContainer[0])).length
                        ? this._toolbox.$(this._config.modalContainer[0])
                        : this._toolbox.$(this._config.modalContainer[1]);
                }
                else {
                    this._globalWindow = this._toolbox.$(this._config.modalContainer);
                    this._globalHtmlBody = this._toolbox.$(this._config.modalContainer);
                }
            }
            else {
                var classNameBody = this._entityTemplate.attr('data-name-body');
                if (classNameBody) {
                    this._globalWindow = this._toolbox.$(classNameBody);
                    this._globalHtmlBody = this._toolbox.$(classNameBody);
                }
            }
            var classNameContent = this._entityTemplate.attr('data-name-content');
            var classNameContent$ = this._toolbox.$(classNameContent);
            if (classNameContent$ &&
                (classNameContent$.hasClass('tor-modal-content') ||
                    classNameContent$.attr('id') === 'or-dialog-modal')) {
                this._torPopup = true;
            }
        }
        else {
            if (this._config.offBodyInjection) {
                this.destroy();
                return;
            }
            this._globalWindow = this._window;
            this._globalHtmlBody = this._htmlBody;
        }
        /**
         * @type {jQuery|HTMLElement}
         * @private
         * @desc simulator container
         */
        this._fixedToContainer = this._toolbox.$(this._config.fixedTo);
        if (this._fixedToContainer.length > 0) {
            /**
             * @type {Number}
             * @private
             * @desc height of simulator container
             */
            this._fixedToHeight = this._fixedToContainer.height();
        }
        else {
            this._fixedToHeight = 0;
        }
        /**
         * @type {boolean}
         * @private
         * @desc off height calculation for bss-popup-content
         */
        this._isOffHeightCalculation = this._config.offHeightCalculation
            ? this._config.offHeightCalculation
            : false;
        /**
         * @type {jQuery|HTMLElement}
         * @private
         * @desc external fixed element
         * parameter used only in _getFixedOuterOffset() function - this function not used anymore
         */
        this._fixedOuterEl = this._toolbox.$(this._config.fixedOuterElementSelector);
        /**
         * @type {Number}
         * @private
         * @desc fixed container height
         */
        this._containerHeight = this._componentTemplate.outerHeight();
        /**
         * @type {Number}
         * @private
         * @desc height of window
         */
        this._windowHeight = this._globalWindow.height();
        /**
         * @type {jQuery|HTMLElement}
         * @private
         * @desc depends top element container
         */
        this._$target = this._toolbox.$(this._config.dependsTopSelector);
        /**
         * @type {Number}
         * @private
         * @desc height of depends top element container
         */
        this._targetHeight = this._$target.outerHeight();
        /**
         * @type {String}
         * @private
         * @desc custom event for recalculate position
         */
        this._customEventRecalculatePos =
            this._config.customEventRecalculatePos || null;
        if (this._config.dependsSelector) {
            /**
             * @type {jQuery|HTMLElement}
             * @desc active product container
             * @private
             */
            this._activeProduct = this._globalHtmlBody.find(this._config.dependsSelector);
        }
        else {
            this._activeProduct = null;
        }
        if (this._activeProduct && this._activeProduct.length === 1) {
            this._componentTemplate.addClass('is-active');
        }
        /**
         * @type {jQuery|HTMLElement}
         * @desc others fixed container that scroll to
         *  @private
         */
        this._otherContainers = this._entityTemplate.find('.bss-fixed-container');
        this._getCalculationData();
        this._isScrollEventOff = true;
        this._isResizeEventOff = true;
        this._bindScroll();
        this._bindResize();
        this._eventManager.subscribe('bss-fixed-container-start-scroll-for-' + this._config.componentId, this._bindScroll.bind(this), this.subscriberPrefix + this._config.componentId);
        this._eventManager.subscribe('bss-fixed-container-stop-scroll-for-' + this._config.componentId, this._unbindScroll.bind(this), this.subscriberPrefix + this._config.componentId);
        this._eventManager.subscribe('bss-fixed-container-start-resize-for-' + this._config.componentId, this._bindResize.bind(this), this.subscriberPrefix + this._config.componentId);
        this._eventManager.subscribe('bss-fixed-container-stop-resize-for-' + this._config.componentId, this._unbindResize.bind(this), this.subscriberPrefix + this._config.componentId);
        this._eventManager.subscribe('bss-entity-created-' + this._config.entityInstanceId, this._updateOtherContainers.bind(this), this.subscriberPrefix + this._config.componentId);
        this._eventManager.subscribe('bss-entity-update-' + this._config.entityInstanceId, this._onResize.bind(this), this.subscriberPrefix + this._config.componentId);
        this._eventManager.subscribe('bss-tab-changed-' + this._config.dependsEvent, this._checkDisplay.bind(this), this.subscriberPrefix + this._config.componentId);
        if (this._customEventRecalculatePos) {
            this._eventManager.subscribe(this._customEventRecalculatePos, this._onResize.bind(this), this.subscriberPrefix + this._config.componentId);
        }
    };
    /**
     * @desc bind window scroll event
     * @private
     */
    BSSTemplateComponent.prototype._bindScroll = function () {
        logger.info('BSSTemplateComponent ' +
            this._config.componentId +
            ' => function : _bindScroll');
        if (this._isScrollEventOff) {
            var isStickyPosition = this._torPopup && !this._entityTemplate.is('.browser-edge ');
            if (!isStickyPosition) {
                this._globalWindow.on('scroll.' + this._config.componentId, this._getCalculationData.bind(this));
            }
            this._isScrollEventOff = false;
        }
    };
    /**
     * @desc unbind window scroll event
     * @private
     */
    BSSTemplateComponent.prototype._unbindScroll = function () {
        logger.info('BSSTemplateComponent ' +
            this._config.componentId +
            ' => function : _unbindScroll');
        this._globalWindow.off('scroll.' + this._config.componentId);
        this._isScrollEventOff = true;
    };
    /**
     * @desc bind window scroll event
     * @private
     */
    BSSTemplateComponent.prototype._bindResize = function () {
        logger.info('BSSTemplateComponent ' +
            this._config.componentId +
            ' => function : _bindResize');
        if (this._isResizeEventOff) {
            this._window.on('resize.' + this._config.componentId, this._onResize.bind(this));
            this._isResizeEventOff = false;
        }
    };
    /**
     * @desc unbind window scroll event
     * @private
     */
    BSSTemplateComponent.prototype._unbindResize = function () {
        logger.info('BSSTemplateComponent ' +
            this._config.componentId +
            ' => function : _unbindResize');
        this._window.off('resize.' + this._config.componentId);
        this._isResizeEventOff = true;
    };
    /**
     * @desc on resize - get calculation data
     * @private
     */
    BSSTemplateComponent.prototype._onResize = function () {
        logger.info('BSSTemplateComponent ' +
            this._config.componentId +
            ' => function : _onResize');
        this._windowHeight = this._globalWindow.height();
        this._targetHeight = this._$target.outerHeight();
        this._getCalculationData();
    };
    /**
     * @desc get calculation data
     * @private
     */
    BSSTemplateComponent.prototype._getCalculationData = function () {
        logger.info('BSSTemplateComponent ' +
            this._config.componentId +
            ' => function : _getCalculationData');
        /**
         * @type {Number}
         * @private
         * @desc scroll top of window
         */
        this._windowTop = this._globalWindow.scrollTop();
        if (this._fixedToContainer.length > 0) {
            this._fixedToHeight = this._fixedToContainer.height();
            /**
             * @type {Number}
             * @private
             * @desc position top of fixed container that fixed to
             */
            this._fixedToPositionTop = this._fixedToContainer.offset().top;
        }
        else {
            this._fixedToHeight = 0;
            this._fixedToPositionTop = 0;
        }
        /**
         * @type {Number}
         * @private
         * @desc position top of fixed container target
         */
        if (this._$target.length) {
            this._targetPosition = this._$target.offset().top;
        }
        this._containerHeight = this._componentTemplate.outerHeight();
        this._checkDisplayFixedContainer();
    };
    /**
     * @desc after all components are added we update this._otherContainers to have all fixed containers, because when we create this container not all components/slide where created
     * @private
     */
    BSSTemplateComponent.prototype._updateOtherContainers = function () {
        logger.info('BSSTemplateComponent: ' +
            this._config.componentId +
            ' => function : _updateOtherContainers');
        this._otherContainers = this._entityTemplate.find('.bss-fixed-container');
        this._onResize();
    };
    /**
     * @desc get navigation offset top - based on outer fixed element height and position top
     * @return {Number} outerOffset - navigation offset top
     * function not used
     * @private
     */
    BSSTemplateComponent.prototype._getFixedOuterOffset = function () {
        logger.info('BSSTemplateComponent ' +
            this._config.componentId +
            ' => function : _getFixedOuterOffset');
        var outerOffset = 0;
        if (this._fixedOuterEl && this._fixedOuterEl.is(':visible')) {
            outerOffset =
                this._fixedOuterEl.outerHeight() + this._fixedOuterEl.position().top;
        }
        return outerOffset;
    };
    /**
     * @desc which fixed container should be display, depends on component element
     * @private
     */
    BSSTemplateComponent.prototype._checkDisplay = function () {
        logger.info('BSSTemplateComponent: ' +
            this._config.componentId +
            ' => function : _checkDisplay');
        if (this._config.dependsSelector &&
            this._config.dependsSelector.length > 0) {
            this._activeProduct = this._entityTemplate.find(this._config.dependsSelector);
        }
        else {
            this._activeProduct = null;
        }
        this._otherContainers.removeClass('is-active');
        this._otherContainers.css({ display: 'none' });
        this._componentTemplate.addClass('is-active');
        this._onResize();
    };
    /**
     * @desc check display of fixed container
     * @private
     */
    BSSTemplateComponent.prototype._checkDisplayFixedContainer = function () {
        logger.info('BSSTemplateComponent ' +
            this._config.componentId +
            ' => function : _checkDisplayFixedContainer');
        var isPopupEsOA = false;
        if (this._isInPopup &&
            typeof this._config.fixedTo !== 'undefined' &&
            this._config.fixedTo.includes('onlineApproval') &&
            this._fixedToContainer.attr('class') !== 'undefined' &&
            this._fixedToContainer.attr('class').includes('es_oa') &&
            typeof this._toolbox.$('.bss-step-navigation_form') !== 'undefined') {
            isPopupEsOA = true;
        }
        var res = this._resolution.getCurrent();
        if (this._componentTemplate.hasClass('bss-fixed-container--tor-popup')) {
            this._componentTemplate.removeClass('bss-fixed-container--tor-popup');
        }
        if (res && res === 'xs' && this._config.offFixedTemplateXS) {
            this._componentTemplate.css({
                display: 'none',
                position: 'relative',
                bottom: '0',
            });
            if (this._componentTemplate.hasClass('is-active')) {
                this._componentTemplate.css({ display: 'block' });
            }
            if (this._isInPopup && this._componentTemplate.hasClass('is-active')) {
                this._fixedToContainer.css({ 'padding-bottom': 0 });
            }
        }
        else {
            var isStickyPosition = this._torPopup && !this._entityTemplate.is('.browser-edge ');
            var stickyPosition = this._entityTemplate.hasClass('browser-safari')
                ? '-webkit-sticky'
                : 'sticky';
            var position = isStickyPosition ? stickyPosition : 'fixed';
            if (this._config.fixedPosition) {
                this._componentTemplate.css({ position: position });
            }
            else {
                this._componentTemplate.css({ position: 'absolute' });
            }
            if (this._isInPopup && this._componentTemplate.hasClass('is-active')) {
                if (this._entityTemplate.is('.bss-lexus-gb-base-new') ||
                    isStickyPosition) {
                    this._fixedToContainer.css({ 'padding-bottom': 0 });
                }
                else if (!isPopupEsOA) {
                    this._fixedToContainer.css({
                        'padding-bottom': this._componentTemplate.outerHeight(),
                    });
                }
                var parent_1 = this._globalWindow.parent();
                var heightWindow = this._window.height();
                var width = this._fixedToContainer.outerWidth();
                var bottom = parseFloat(parent_1.css('border-bottom-width'));
                if ('class' in this._config &&
                    this._config.class.indexOf('bss-fixed-container--adjust-bottom-position') !== -1) {
                    if (parent_1 && parent_1[0]) {
                        var heightToParentBottom = parent_1[0].offsetTop + parent_1.height();
                        bottom += heightWindow - heightToParentBottom;
                    }
                }
                if (isNaN(bottom)) {
                    bottom = 0;
                }
                this._componentTemplate.css({
                    display: 'block',
                    bottom: 0 + bottom + 'px',
                    width: parseInt(width),
                });
                if (this._fixedToContainer.hasClass('bss-popup_content') &&
                    this._fixedToContainer.parent().hasClass('bss-popup') &&
                    !this._isOffHeightCalculation) {
                    this._fixedToContainer.css({
                        height: Math.floor(this._fixedToContainer.parent('.bss-popup').height() -
                            this._componentTemplate.outerHeight() -
                            1),
                    });
                }
            }
            else {
                var myBottom = this._targetPosition;
                var windowBottom = this._windowTop + this._windowHeight;
                var containerBottom = this._fixedToPositionTop + this._fixedToHeight;
                var positionBottom = windowBottom - containerBottom - this._containerHeight - 20;
                if (this._componentTemplate.hasClass('is-active')) {
                    if (windowBottom - (this._containerHeight + this._targetHeight - 5) <=
                        myBottom) {
                        this._componentTemplate.css({ display: 'none', bottom: '0' });
                    }
                    else if (windowBottom - this._containerHeight - 20 >=
                        containerBottom) {
                        this._componentTemplate.css({
                            display: 'block',
                            bottom: positionBottom + 'px',
                        });
                    }
                    else {
                        this._componentTemplate.css({ display: 'block', bottom: '0' });
                    }
                }
                else {
                    this._componentTemplate.css({ display: 'none', bottom: '0' });
                }
            }
        }
        //fix for ES OA
        if (isPopupEsOA) {
            var oaForm$ = this._toolbox.$('.bss-step-navigation_form');
            var formBottomPos = oaForm$.offset().top + oaForm$.height() + 20;
            var componentBottomPos = this._toolbox
                .$('#' + this._componentTemplate.attr('id'))
                .position().top;
            //if bottom of form is far above fixed container
            if (formBottomPos < componentBottomPos) {
                this._toolbox
                    .$('.bss-step-navigation_form')
                    .css({ 'padding-bottom': 0 });
            }
        }
        //recalculate
        if (this._isInPopup &&
            this._componentTemplate.hasClass('is-active') &&
            res !== 'xs') {
            this._componentTemplate.css({
                width: this._fixedToContainer.outerWidth(),
            });
        }
    };
    /**
     * @desc Destroys qTip and calls super method
     * @public method
     */
    BSSTemplateComponent.prototype.destroy = function () {
        logger.info('BSSTemplateComponent: ' +
            this._config.componentId +
            ' => function : destroy');
        _super.prototype.destroy.call(this);
    };
    return BSSTemplateComponent;
}(BSSAbstractComponent));
export default BSSTemplateComponent;
